<div class="modal-header" ngxModalDraggable>
  <h3 class="me-4 mb-0">
    <span [ngClass]="eventService.colorsByLevel[event.Level]">
      <svg viewBox="0 0 8 8" class="icon" inlineSVG="{{eventService.iconsByLevel[event.Level]}}">
      </svg>
    </span>
    {{event.Description}}
  </h3>
  <button type="button" class="btn-close ms-2" aria-label="Close" (click)="close()">
  </button>
</div>
<div class="modal-body">
  <pre *ngIf="json; else textTemplate">{{json | json}}</pre>
  <ng-template #textTemplate>
    <pre>{{text}}</pre>
  </ng-template>
</div>
